import { render, staticRenderFns } from "./asiaMap.vue?vue&type=template&id=39c56a92&scoped=true&"
import script from "./asiaMap.vue?vue&type=script&lang=js&"
export * from "./asiaMap.vue?vue&type=script&lang=js&"
import style0 from "./asiaMap.vue?vue&type=style&index=0&id=39c56a92&lang=scss&scoped=true&"
import style1 from "./asiaMap.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c56a92",
  null
  
)

export default component.exports